import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';
import {AR} from '../../../constants/MicroServiceConstants';
import {REVERSALS} from '../../../constants/Lookup';
const initialData = {
  debtorReversalData: {},
  debtorReversalStatus: null,
  dropDownData: {},
  isLoading: false,
  errorMsg: null,
  successMsg: null,
};

const slice = createSlice({
  name: 'debtorReversalEntry',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    postDebtorReversalData: (state, action) => {
      state.debtorReversalStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload.response;
    },
    resetDebtorReversal: (state) => {
      state.debtorReversalStatus = null;
      state.isLoading = false;
    },
    fetchDropDownData: (state, action) => {
      state.dropDownData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    resetMsg: (state, action) => {
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

// Actions

const {
  fetchStart,
  postDebtorReversalData,
  fetchDropDownData,
  resetMsg,
  resetDebtorReversal,
  fetchError,
} = slice.actions;

export const postDebtorReversal = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`${AR}/save/debtorreversalentry`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postDebtorReversalData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchDropdown = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [REVERSALS],
      }),
    ])
      .then((data) => {
        const lookUpApiData = data && data[0] ? data[0] : null;
        if (lookUpApiData && lookUpApiData.status && lookUpApiData.status === 200) {
          dispatch(fetchDropDownData(lookUpApiData.data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetMessage = () => {
  return (dispatch) => {
    dispatch(resetMsg());
  };
};
export const resetStatus = () => {
  return (dispatch) => {
    dispatch(resetDebtorReversal());
  };
};
